import React, { useEffect, useRef, useState } from "react";
import { usePopupStack } from "../../contexts/PopupStackContext";
import { useRefreshContext } from "../context/RefreshContext";
import "./css/Merger.css";
import {deleteContractNote, fetchManualContractNoteNo, saveContractNote} from "@portfolio/utils/PFService";

const Merger = ({ symbol, totalQuantity, totalAmount,onClose, onSave, isDisplayClick = false, contractNoteDTO = {}, clientId }) => {
    const formRef = useRef(null);
    const { refreshPFdata } = useRefreshContext();
    const { push, pop } = usePopupStack();

    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const [mergingInto, setMergingInto] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [narration, setNarration] = useState("");
    const [beforeMergerQuantity, setBeforeMergerQuantity] = useState(0);
    const [beforeMergerTotalAmount, setBeforeMergerTotalAmount] = useState(0);

    useEffect(() => {
        push({ onClose });
        return () => pop();
    }, []);

    useEffect(() => {
        if (isDisplayClick && contractNoteDTO.transactions?.[0]) {
            const txn = contractNoteDTO.transactions[0];
            //setDate(txn.tradeDate || date);

            const parsedDate = new Date(txn.tradeDate);
            const formattedDate = parsedDate.getFullYear() + "-" +
                String(parsedDate.getMonth() + 1).padStart(2, "0") + "-" +
                String(parsedDate.getDate()).padStart(2, "0");

            setDate(formattedDate);

            //const parsedDate = new Date(txn.tradeDate[0], txn.tradeDate[1] - 1, txn.tradeDate[2]);
            setQuantity((-1 * txn.quantity) || 0);
            setMergingInto(txn.mergerDetails?.mergedIntoSymbol || "");
            setNarration(txn.narration || "");
            setBeforeMergerQuantity(contractNoteDTO.transactions[0].mergerDetails.beforeMergerQuantity);
            setBeforeMergerTotalAmount(contractNoteDTO.transactions[0].mergerDetails.beforeMergerTotalAmount);
        } else{
            setBeforeMergerQuantity(totalQuantity);
            setBeforeMergerTotalAmount(totalAmount);
        }
    }, [contractNoteDTO]);

    const handleClose = () => {
        pop();
        onClose();
    };

    const handleSave = async () => {
        if (!mergingInto || quantity <= 0) {
            alert("Please fill all required fields.");
            return;
        }

        let manualNote = contractNoteDTO?.contractNote?.contractNoteNo || "";
        if (!isDisplayClick) {
            manualNote = await fetchManualContractNoteNo("MERGER-CNT-");
        }

        const formData = new FormData(formRef.current);

        const mergerDTO = {
            contractNote: {
                contractNoteNo: manualNote,
                clientId: clientId,
                symbol: symbol,
                tradeDate: formData.get("date"),
                cnoteType: "MERGER",
                brokerName: "",
            },
            cnotesCharge: {
                contractNoteNo: "",
                securitiesTransactionTaxNetTotal: "",
                stampDutyNetTotal: "",
                gstTotal: "",
                payInPayOutObligationNetTotal: "",
                otherCharges: "",
                netAmountNetTotal: "",
            },
            transactions: [
                {
                    type: "MergerTransactionDTO",
                    contractNoteNo: manualNote,
                    clientId: clientId,
                    symbol: symbol,
                    isin: "",
                    quantity: -totalQuantity,
                    weightedAvgPrice: 0,
                    totalValue: 0,
                    netQuantity: -totalQuantity,
                    tradeDate: formData.get("date"),
                    transactionType: "Merger",
                    narration: formData.get("narration"),
                    mergerDetails: {
                        contractNoteNo: manualNote,
                        mergedFromSymbol: symbol,
                        mergedIntoSymbol: formData.get("mergingInto"),
                        tradeDate: formData.get("date"),
                        beforeMergerQuantity: totalQuantity,
                        /*beforeMergerTotalAmount: totalAmount,*/
                        beforeMergerTotalAmount: 0, //we aren't using this field for merger
                    }
                },
                {
                    type: "MergerTransactionDTO",
                    contractNoteNo: manualNote,
                    clientId: clientId,
                    symbol: formData.get("mergingInto"),
                    isin: "",
                    quantity: parseFloat(formData.get("quantity")),
                    weightedAvgPrice: 0,
                    totalValue: 0,
                    netQuantity: parseFloat(formData.get("quantity")),
                    tradeDate: formData.get("date"),
                    transactionType: "Merger",
                    narration: formData.get("narration"),
                    mergerDetails: {
                        contractNoteNo: manualNote,
                        mergedFromSymbol: symbol,
                        mergedIntoSymbol: formData.get("mergingInto"),
                        tradeDate: formData.get("date"),
                        beforeMergerQuantity: totalQuantity,
                        /*beforeMergerTotalAmount: totalAmount,*/
                        beforeMergerTotalAmount: 0,
                    }
                }
            ],
            cnoteType: "MERGER"
        };

        try {
            const result = await saveContractNote(mergerDTO, isDisplayClick);
            if (result.success) {
                refreshPFdata();
                onSave(mergerDTO);
                onClose();
            }
        } catch (err) {
            console.error("Error saving Merger:", err);
        }
    };

    const handleDelete = async () => {
        try {
            const result = await deleteContractNote(contractNoteDTO.contractNote.contractNoteNo); // Wait for save to complete
            if (result.success) {
                refreshPFdata(); // ✅ Now refreshes AFTER the save is successful
                onClose(); // Close the popup after successful Save
            }
        } catch (error) {
            console.error("Error deleting Merger:", error);
        }
    };

    return (
        <div className="merger-overlay" onClick={onClose}>
            <form ref={formRef}>
                <div className="merger-popup" onClick={(e) => e.stopPropagation()}>
                    <h3>Merger</h3>

                    <div className="form-group">
                        <label className="general-label">Merging Company:</label>
                        <input type="text" value={symbol} disabled/>
                    </div>
                    <div className="form-group">
                        <label className="general-label">Before Merger Quantity:</label>
                        <input
                            type="text"
                            name="before-merger-quantity"
                            value={(beforeMergerQuantity ?? 0).toLocaleString()}
                            disabled
                        />
                    </div>
                    {/*<div className="form-group">
                        <label className="general-label">Before Merger Amount:</label>
                        <input
                            type="string"
                            name="before-merger-amount"
                            value={(beforeMergerTotalAmount ?? 0).toLocaleString()}
                            disabled
                        />
                    </div>*/}
                    <h5>Transaction</h5>
                    <div className="form-group">
                        <label className="general-label">Merging Into:</label>
                        <input
                            type="text"
                            name="mergingInto"
                            value={mergingInto}
                            onChange={(e) => setMergingInto(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label className="general-label">Date:</label>
                        <input
                            type="date"
                            name="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Balance Shares after Merger:</label>
                        <input
                            type="number"
                            name="quantity"
                            value={quantity}
                            onChange={(e) => setQuantity(parseFloat(e.target.value) || 0)}
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Narration:</label>
                        <textarea
                            name="narration"
                            value={narration}
                            onChange={(e) => setNarration(e.target.value)}
                            rows="2"
                            style={{width: "80%", resize: "vertical"}}
                        />
                    </div>

                    <div className="contract-buttons">
                        {isDisplayClick && (
                            <button type="button" className="delete-button" onClick={handleDelete}>
                                Delete CNote
                            </button>
                        )}
                        <div className="right-buttons">
                            <button type="button" className="save-button" onClick={handleSave}>Save</button>
                            <button type="button" className="cancel-button" onClick={handleClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Merger;
